import { render, staticRenderFns } from "./CourierRegister.vue?vue&type=template&id=a71b9460&scoped=true&"
import script from "./CourierRegister.vue?vue&type=script&lang=js&"
export * from "./CourierRegister.vue?vue&type=script&lang=js&"
import style0 from "./CourierRegister.vue?vue&type=style&index=0&id=a71b9460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71b9460",
  null
  
)

export default component.exports